import React, { createContext, useContext, useEffect, useState } from "react";
import api, { apiErrorText } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null while loading
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("cf_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("cf_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password, otp) => {
    try {
      const payload = { email, password };
      if (otp) payload.otp = otp;
      const { data } = await api.post("/auth/login", payload);
      if (data.requires_2fa) {
        return {
          ok: false,
          requires2fa: true,
          setupRequired: data.setup_required,
          totpSecret: data.totp_secret,
          otpauthUri: data.otpauth_uri,
        };
      }
      localStorage.setItem("cf_token", data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiErrorText(e) };
    }
  };

  const logout = () => {
    localStorage.removeItem("cf_token");
    localStorage.removeItem("cf_user");
    setUser(false);
  };

  const refreshMe = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  };

  const hasPermission = (p) =>
    user && (user.is_master || (user.permissions || []).includes(p));

  return (
    <AuthContext.Provider
      value={{ user, ready, login, logout, refreshMe, hasPermission }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
